import { Message } from '../types/message';

export function populateShowUserInfo(list: Message[]) {
  return list.reduce(
    (acc, curr) => [
      ...acc,
      {
        ...curr,
        showUserInfo:
          acc.at(-1)?.type === curr.type &&
          acc.at(-1)?.userId === curr.userId &&
          acc.at(-1)?.impersonate === curr.impersonate
            ? false
            : true,
      },
    ],
    [] as Message[]
  );
}
